import * as actions from './actions';
import * as logics from './logics';
import * as selectors from './selectors';

import reducers from './reducers';

const userImage = { reducers, actions, logics, selectors };
export default userImage;
